/**
 * Created by user on 2018/1/31/031.
 */

import { array_unique } from 'array-hyper-unique';

/**
 * 和諧/河蟹
 *
 * @type {string[][]}
 */
export const table = array_unique([
	'噁心',
	'触手',
	'白痴',
	'打倒',
	'固守',
	'貴族',
	'自由',
	'討伐',
	'竊聽',
	'色情',
	'禁止',
	'淫穢',
	'下流',
	'含著',
	'調教',
	'情欲',
	'尸体',
	'凌辱',
	'幹掉',
	'非法',
	'激烈',
	'互毆',
	'求愛',
	'間諜',
	'賭局',
	'下賤',
	'爆炸',
	'呻吟',
	'屁股',
	'笨蛋',
	'蠢货',
	'洗脑',
	'魅惑',
	'狂化',
	'混乱',
	'是非',
	'弱智',
	'死掉',
	'日本',
	'法克',
	'畜生',
	'麻痹',
	'废物',
	'娼婦',
	'娼妓',
	'男娼',
	'男妓',
	'卖春',
	'流氓',
	'出卖肉体',
	'交合',
	'卖人',
	'強姦',
	'強奸',
	'反法',
	'禁药',
	'合体',
	'乱交会',
	'乱交',
	'贞操',
	'比基尼',
	'邪教',
	'非法',
	'妓院',
	'赌场',
	'治安',
	'警察',
	'口大',
	'政治',
	'逮捕',
	'法律',
	'政敌',
	'合法',
	'措施',
	'毒品',
	'性感',
	'混蛋',
	'胸部',
	'妖艳',
	'傢伙',
	'制作',
	'算是',
	'法理',
	'肉欲',
	'做愛',
	'利用',
	'注入',
	'少女',
	'色狼',
	'床上',
	'运动',
	'今晚',
	'摸着',
	'公粮',
	'诱惑',
	'兴奋',
	'饥渴',
	'少妇',
	'回復',
	'身体',
	'鼓起',
	'強健',
	'抓住',
	'杀害',
	'黑暗',
	'地震',
	'叫声',
	'引诱',
	'主谋',
	'游街',
	'旺盛',
	'燃烧',
	'基地',
	'垃圾',
	'觉醒',
	'愚蠢',
	'高潮',
	'蛋疼',
	'禁书',
	'妊娠',
	'翻弄',
	'射出',
	'毛骨悚然',
	'绝望的魔手',
	'肉身',
	'肉体',
	'艳丽',
	'绝望',
	'魔手',
	'代价',
	'防卫战',
	'较高',

	'体位',
	'出改',
	'善再',
	'自慰',
	'较高',

	'谄媚',

	'違背人倫',
	'尼玛',
	'阿尼玛',
	'断頭台',
	'断頭',
	'虐杀',

	'色女',
	'麻藥',

	'反国家',
	'殺戮',

	'侵犯',
	'賄賂',
	'斩首',

	'军事政变',
	'政变',
	'杀人',
	'国家颠覆',
	'颠覆',
	'鲜血',
	'露出',
	'内脏',
	'血水',

	'赌博',
	'俘虏',
	'發騷',
	'死刑',
	'殺死',
	'殺掉',
	'背叛',
	'性女',

]);

/**
 * 去和諧時會以第一個項目為返回結果
 *
 * @type {string[][]}
 */
export const table2 = array_unique([
	['裸体', '果体', new String('裸$2')],
	['奴隷', '奴隶',],
]);

export const table3 = array_unique([
	['強姦', '弓虽姦'],
	['強奸', '弓虽女干', '弓虽奸'],

	['娼婦', '女昌妇'],
	['娼妓', '女昌妓', '女昌女支'],
]);

export default exports as typeof import('./table');
